import { getAsset } from "../utils/assets.utils";
import { addVueComponent, removeVueComponent } from "../utils/vue.utils";
import { Endpoints } from "../../endpoints";
import { waitForLoaderToHide } from "../utils/scene.utils";
import { getState, transitionTo } from "../../vue/utils/aframe.utils";
import ToggleVolume from "../../vue/components/toggle-volume.component.vue";
import { sendOnVideoStart } from "../../vue/utils/dataCollection.utils";
import { resetOrbitalCamera } from "../utils/camera.utils";
import { requestDeviceOrientation } from "../utils/device-orientation.utils";
import { addCaptionsToVideo } from "../utils/subtitles.utils";

AFRAME.registerComponent("video-2d-scene-controller", {
  events: {
    sceneEnter: async function (e) {
      const { routeParameters } = e.detail;
      const { category, submenu = "", id } = routeParameters;

      const { src, backScene } = await this.el.sceneEl.systems["data"].fetch(
        Endpoints.models(category, submenu, id)
      );

      this.backScene = backScene;
      this.category = category;
      this.id = id;

      const hasOrientationPermission = await requestDeviceOrientation();
      this.useLookControls =
        hasOrientationPermission ||
        (!getState().isIOS && getState().mouseDetected);
      if (this.useLookControls) {
        this.el.sceneEl.emit("activateLookCamera");
      } else {
        this.el.sceneEl.emit("activateOrbitalCamera", {
          minDistance: 1,
          maxDistance: 1,
          panSpeed: 0.1,
          rotateSpeed: -0.1,

          target: { x: 0, y: 0, z: -5 },
        });
      }
      this.elVideoPlane.setAttribute("visible", false);
      this.el.sceneEl.camera.el.setAttribute("rotation", "0 0 0");

      setTimeout(async () => {
        await this.loadVideo(src);
        this.elHeader.setAttribute("generic-menu-header", {
          asset: id,
          category,
          enabled: true,
          submenu,
        });
        waitForLoaderToHide();

        // send video load event
        sendOnVideoStart({ contentName: id, contentCategory: submenu });
      });
    },

    sceneExiting: function () {
      this.elVideo &&
        this.elVideo.pause() &&
        this.elVideo.removeEventListener("ended", this.gotoVideoCategory);

      document.querySelector("a-assets").appendChild(this.elVideo);

      if (this.vueToggleVolume) {
        removeVueComponent(this.vueToggleVolume);
      }
      this.vueToggleVolume = null;
    },

    sceneExit: function () {
      if (!this.useLookControls && !getState().userIsInVR) {
        resetOrbitalCamera();
      }

      this.el.sceneEl.emit("clearSceneInformation");
      this.elHeader.setAttribute("generic-menu-header", "enabled", false);
      this.elVideoPlane.setAttribute("color", "#000");
    },

    goBack: function () {
      const backScene = this.el.sceneEl.systems["router"].getBackScene(this.backScene);
      transitionTo(backScene.split("/"));
    },
  },

  category: null,
  elVideoSelector: null,
  elVideoPlane: null,
  elVideo: null,

  init: function () {
    this.gotoVideoCategory = this.gotoVideoCategory.bind(this);
    this.elHeader = document.querySelector(".header");
    this.elVideoPlane = document.getElementById("video__plane");
  },

  loadVideo: async function (src) {
    this.elVideoPlane.removeAttribute("animation");
    this.elVideoPlane.setAttribute("material", "color", "#000");
    this.elVideoPlane.setAttribute("visible", false);

    const video = await getAsset(src, { showLoader: true });
    const { browser, isIOS } = getState();
    if (browser.name === "safari" || isIOS) {
      this.vueToggleVolume = addVueComponent(ToggleVolume);
      this.vueToggleVolume.addEventListener("buttonPressed", () => {
        video.muted = false;
        removeVueComponent(this.vueToggleVolume);
        this.vueToggleVolume = null;
      });
    } else {
      video.muted = false;
    }

    video.innerHTML = "";
    await addCaptionsToVideo(video, this.category, this.id);

    const wrapper = document.createElement("div");
    wrapper.classList.add("video-2d-player-wrapper");
    wrapper.appendChild(video);

    video.classList.add("video-2d-player");
    video.currentTime = 0;
    video.volume = 1;
    video.play();
    video.addEventListener("ended", this.gotoVideoCategory);
    document.body.appendChild(wrapper);

    const videoWidth =
      video.videoWidth > video.videoHeight
        ? video.videoWidth / video.videoHeight
        : 1;
    const videoHeight =
      video.videoWidth > video.videoHeight
        ? 1
        : video.videoWidth / video.videoHeight;

    this.elVideoPlane.setAttribute("width", videoWidth);
    this.elVideoPlane.setAttribute("height", videoHeight);
    this.elVideoPlane.setAttribute("animation", {
      easing: "linear",
      property: "components.material.material.color",
      from: "#000",
      to: "#fff",
      type: "color",
    });
    this.elVideoPlane.setAttribute(
      "material",
      "src",
      `#${video.getAttribute("id")}`
    );
    this.elVideoPlane.setAttribute("visible", true);
    this.elVideo = video;

    return true;
  },

  gotoVideoCategory: function (doNotAnimate) {
    transitionTo(this.backScene.split("/"));
  },
});
